export default "__VITE_ASSET__8f66cc32__"